import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const GlobalStatusChart = ({ data }) => {
  const chartData = data ? [
    { name: 'Aprobadas', value: data.approved, color: '#10b981' },
    { name: 'Rechazadas', value: data.rejected, color: '#ef4444' },
    { name: 'En proceso', value: data.inProcess, color: '#f59e0b' }
  ] : [];

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0];
      const percentage = ((data.value / total) * 100).toFixed(1);
      return (
        <div className="bg-white p-3 border rounded shadow-lg">
          <p className="font-semibold">{data.name}</p>
          <p className="text-sm text-gray-600">
            {data.value} requisiciones ({percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  const CustomLegend = (props) => {
    const { payload } = props;
    return (
      <div className="flex justify-center mt-4">
        <div className="flex flex-col gap-2">
          {payload.map((entry, index) => (
            <div key={index} className="flex items-center gap-2">
              <div 
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-gray-600">
                {entry.value}: {chartData[index]?.value || 0}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Estado Global de Requisiciones</h3>
        <p className="chart-subtitle">Distribución por estado - Últimos 30 días</p>
      </div>
      
      <div className="chart-content">
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={5}
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend content={<CustomLegend />} />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex items-center justify-center h-64 text-gray-500">
            <div className="text-center">
              <div className="text-4xl mb-2">📊</div>
              <p>No hay datos disponibles</p>
            </div>
          </div>
        )}
      </div>
      
      <div className="chart-footer">
        <div className="chart-insight">
          {total > 0 && (
            `${((chartData.find(d => d.name === 'Aprobadas')?.value || 0) / total * 100).toFixed(1)}% de aprobación`
          )}
        </div>
        <div className="chart-metric">
          Total: {total} requisiciones
        </div>
      </div>
    </div>
  );
};

export default GlobalStatusChart; 